import { useState, useEffect } from "react";
import { SystemLayoutStyled } from "./styled";
import { Outlet } from "react-router-dom";
import { userService } from "apiServices";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setReduxAuthen } from "store/reducers/authenReducer";
import { setReduxWallet } from "store/reducers/walletReducer";
import { ROUTE_PATH } from "utils/constants/routePath";
import "moment/locale/th"; // ต้อง import locale ภาษาไทย
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
  LanguageWidget,
  MenuBarWidget,
  Navbar,
  NotificationWidget,
  PopupWidget,
  FooterWidget,
} from "widgets";
import { Displays, Headers } from "components";
import useIsMobile from "utils/hooks/useIsMobile";

const SystemLayout = () => {
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isMobile = useIsMobile();

  const [_isLoading, _setIsLoading] = useState(true);

  useEffect(() => {
    moment.locale(i18n.language);
    _fetchMyInfomation();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const _fetchMyInfomation = async () => {
    let resArr = await Promise.all([
      userService.GET_MY_PROFILE(),
      userService.GET_MY_WALLET(),
      userService.GET_PDPA_LATEST(),
    ]);
    if (resArr) {
      dispatch(setReduxAuthen(resArr[0].data));
      dispatch(setReduxWallet(resArr[1].data));
      if (
        !resArr[0].data.pdpa_accepted_latest_ref_id ||
        resArr[0].data.pdpa_accepted_latest_ref_id !== resArr[2].data._id
      ) {
        navigate(`${ROUTE_PATH.PDPA}`);
      }
      _setIsLoading(false);
    }
  };

  return (
    <SystemLayoutStyled>
      {isMobile ? (
        <section className="mobile_system_layout">
          <div className="header_mainlayout">
            <Headers.Logo mb="0px" />
            <div className="lang_noti_block">
              <LanguageWidget />
              <NotificationWidget />
            </div>
          </div>
          <div className="notification_mainlayout"></div>
          <div className="popup_mainlayout">
            <PopupWidget />
          </div>
          <div className="body_mainlayout">
            {_isLoading ? <Displays.Loading /> : <Outlet />}
          </div>
          <div className="menu_mainlayout">
            <MenuBarWidget />
          </div>
        </section>
      ) : (
        <section className="desktop_system_layout">
          <Navbar />
          <div className="popup_mainlayout">
            <PopupWidget />
          </div>
          <div className="body_mainlayout">
            {_isLoading ? <Displays.Loading /> : <Outlet />}
          </div>
          <FooterWidget />
        </section>
      )}
    </SystemLayoutStyled>
  );
};

export default SystemLayout;
